<template>
  <table id="tabCluster">
    <tr>
      <td class="desc-title headTd">{{ $t("message.noiseSensor") }}</td>
      <td class="headTd" colspan="2">PRA-ANS</td>
    </tr>
    <tr>
      <td></td>
      <td class="device-content">{{ $t("message.active_ports_mps_and_switch") }}</td>
      <td class="qty-content">
        <!-- <input type="number" class="form-control form-control-sm" min=0 :max="maxPoE"
        v-model.lazy="poe" @change="inputValue()"/> -->
        <select class="form-control form-control-sm" style="width: 70px;" name="" id="" v-model="poe" @change="inputValue()">
          <option v-for="n in maxPoe + 1" :key="n" :value="n - 1">
            {{ n - 1 }}
          </option>
        </select>
      </td>
    </tr>
    <tr class="wiersz-pusty"></tr>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NoiseSensor',
  props: ['title', 'values', 'clear', 'cluster'],
  data () {
    return {
      poe: 0
    }
  },
  watch: {
    clearing (newValue, oldValue) {
      if (newValue === true) {
        this.poe = 0
      }
    },
    clear (newValue, oldValue) {
      if (newValue === true) {
        this.poe = 0
      }
    },
    values (newValue, oldValue) {
      if (newValue !== null) {
        this.poe = this.values.poePorts
      }
    }
    // desktop (newValue, oldValue) {
    //   this.poe = Number(newValue) + Number(this.wallmount)
    // },
    // wallmount (newValue, oldValue) {
    //   this.poe = Number(newValue) + Number(this.desktop)
    // }
  },
  computed: {
    ...mapGetters('app', ['clearing']),
    // maxPoE () {
    //   return 2 // (Number(this.desktop) + Number(this.wallmount))
    // },
    // Ile portów zajmują INNE komponenty (bez noiseSensor)
    usedByOthers () {
      if (!this.cluster) return 0
      return (
        Number(this.cluster.callStation ? this.cluster.callStation.csDesktop : 0) +
        Number(this.cluster.callStation ? this.cluster.callStation.csWall : 0) +
        Number(this.cluster.panelControl ? this.cluster.panelControl.poePorts : 0) +
        Number(this.cluster.interfaceControl ? this.cluster.interfaceControl.poePorts : 0) +
        Number(this.cluster.interfaceAudio ? this.cluster.interfaceAudio.poePorts : 0)
      )
    },
    // Max dla noiseSensor = 2 - zajęte przez innych
    maxPoe () {
      if (this.cluster) {
        var ethernetPowerSupply = (this.cluster.powerSupply && this.cluster.powerSupply.ethernet) ? this.cluster.powerSupply.ethernet : 2
        var ethernetOutput48one = (this.cluster.output48one && this.cluster.output48one.selected === 'PRA-ES8P2S') ? this.cluster.output48one.ethernet : 0
        var ethernetOutput48two = (this.cluster.output48two && this.cluster.output48two.selected === 'PRA-ES8P2S') ? this.cluster.output48two.ethernet : 0
        var ethernetOutput48three = (this.cluster.output48three && this.cluster.output48three.selected === 'PRA-ES8P2S') ? this.cluster.output48three.ethernet : 0
        var allEthernets = Number(ethernetPowerSupply) + Number(ethernetOutput48one) + Number(ethernetOutput48two) + Number(ethernetOutput48three)
        return Math.max(0, allEthernets - this.usedByOthers)
      }
      return 0
    }
  },
  methods: {
    inputValue () {
      this.$emit('allValues', this.poe)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Devices/NoiseSensor.vue